import uniqueId from 'lodash/uniqueId'
import { StrictMode, useRef } from 'react'
import type { VFC } from 'react'
import { Size, Theme } from '@opallabs/gem'
import { Icon, InputLabel } from '@opallabs/lapidary'
import { TabItem, Tabs } from '@opallabs/lapidary-unstable'
import { ImageAlignment, ImageAlignmentGlyph } from '../../types'
import * as styles from '../styles'
import type { SidebarProps } from '../types'

const glyphForValue = (name: ImageAlignment): string =>
  ImageAlignmentGlyph[name]

const makeTab = (value: ImageAlignment): TabItem => ({
  icon: (
    <Icon
      ariaHidden={true}
      glyph={glyphForValue(value)}
      height={Size.Icon}
      useHypernova={true}
      width={Size.Icon}
    />
  ),
  label: `Image on ${value}`,
  value,
})
const tabList = Object.values(ImageAlignment).map(makeTab)

export type Props = Pick<SidebarProps, 'alignment' | 'theme'> &
  Readonly<{
    onChange(value: ImageAlignment): void
  }>

export const AlignmentSection: VFC<Props> = ({
  alignment,
  onChange,
  theme = 'light',
}) => {
  const htmlId = useRef(uniqueId('sidebar-image-alignment'))

  return (
    <StrictMode>
      <InputLabel
        inputId={htmlId.current}
        styleOverrides={styles.label(theme as Theme)}
        text="Image Position"
        theme={theme}
      />

      <Tabs
        defaultValue={alignment}
        displayLabel={false}
        htmlId={htmlId.current}
        onChange={(value: string) => onChange(value as ImageAlignment)}
        tabList={tabList}
        theme={theme}
      />
    </StrictMode>
  )
}
AlignmentSection.displayName =
  'Hubble: AlignmentSection ← Sidebar ← SlideEditor'
